import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/hypotheses")({
  component: HypothesesView,
});

function HypothesesView() {
  const { t } = useTranslation("common");

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-4">{t("hypotheses.title")}</h2>
      <p className="text-muted-foreground">{t("hypotheses.placeholder")}</p>
    </div>
  );
}
